<template>
  <main>
    <hero :heading="entry.title" :subheading="entry.hero.subheading" :images="entry.heroImages" position="bottom" />
    <div class="c-section">
      <div class="o-wrapper o-wrapper--small">
        <div class="o-box-off u-ff-alt u-mb u-mb+@tablet u-pb" v-html="entry.body"></div>
        <div class="o-box-off">
          <panel v-for="panel in entry.panels" :key="panel.id" :heading="panel.heading" :body="panel.body" :images="panel.images" />
        </div>
      </div>
    </div>
    <banner />
  </main>
</template>

<script>
import axios from 'axios'
import Hero from '@/components/Hero.vue'
import Banner from '@/components/Banner.vue'
import Panel from '@/components/Panel.vue'

export default {
  name: 'About',
  metaInfo () {
    return {
      title: this.title
    }
  },
  components: {
    Hero: Hero,
    Banner: Banner,
    Panel: Panel
  },
  data () {
    return {
      title: '',
      entry: null
    }
  },
  mounted () {
    this.getEntry()
  },
  methods: {
    getEntry () {
      axios
        .get('api/about.json')
        .then(response => {
          this.entry = response.data
          this.title = this.entry.title
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/About.vue